import { formBundlesApi } from 'app/services/api';
import _ from 'lodash';
import { normalize, schema } from 'normalizr';

import { SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { getFormattedFormBundleFormData } from 'utils/forms';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const FormBundleElementInclude = {
  EXPRESSION_VALUE: 'ExpressionValue',
};

export const formBundleFormsSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: 'formBundleFormId' },
);

export const FORM_BUNDLE_FORM_ACTION_TYPE = createNamedActions('formBundleForms', {
  EDIT_FORM: 'EDIT_FORM',
  DELETE_FORM: 'DELETE_FORM',
  GET_FORMS: 'GET_FORMS',
  REORDER_FORMS: 'REORDER_FORMS',
  CREATE_FORM: 'CREATE_FORM',
  RESET_STORE: 'RESET_STORE',
  REORDER_BY_ELEMENT_ID: 'REORDER_BY_ELEMENT_ID',
});

export const editFormBundleFormAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await formBundlesApi.editBundleForm(params);

  return dispatch({
    type: FORM_BUNDLE_FORM_ACTION_TYPE.EDIT_FORM,
    payload: getFormattedFormBundleFormData(data),
  });
});

export const deleteFormBundleFormAction = catchAsyncActionError(
  ({ formBundleFormId, formBundleId }) =>
    async dispatch => {
      await formBundlesApi.deleteBundleForm({ formBundleFormId, formBundleId });

      return dispatch({
        type: FORM_BUNDLE_FORM_ACTION_TYPE.DELETE_FORM,
        payload: { formBundleFormId, formBundleId },
      });
    },
);

export const getFormBundleFormsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await formBundlesApi.getBundleForms(params);

  return dispatch({
    type: FORM_BUNDLE_FORM_ACTION_TYPE.GET_FORMS,
    payload: normalize(_.sortBy(data.map(getFormattedFormBundleFormData), 'orderNumber'), [
      formBundleFormsSchema,
    ]).entities.data,
  });
});

/* The raw elements, expressions included, for a read-only consumer that needs the form
   name the store's formatted shape drops and must not disturb the bundle editor's slice.
   A 403 stays with the caller: the shared interceptor would otherwise reload the page. */
export const getFormBundleElementsAction = catchAsyncActionError(({ formBundleId }) => async () => {
  const { data } = await formBundlesApi.getBundleForms({
    formBundleId,
    params: { include: [FormBundleElementInclude.EXPRESSION_VALUE] },
    paramsSerializer: { indexes: null },
    ...SKIP_FORBIDDEN_RESPONSE_CONFIG,
  });

  return data;
});

export const createFormBundleFormAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await formBundlesApi.createBundleForm(params);

  return dispatch({
    type: FORM_BUNDLE_FORM_ACTION_TYPE.CREATE_FORM,
    payload: getFormattedFormBundleFormData(data),
  });
});

export const setReorderByElementIdAction = list => ({
  type: FORM_BUNDLE_FORM_ACTION_TYPE.REORDER_BY_ELEMENT_ID,
  payload: list,
});

export const reorderFormBundleByElementIdAction = catchAsyncActionError(
  params => async dispatch => {
    dispatch(setReorderByElementIdAction(params.list));
    await formBundlesApi.editBundleFormOrder(params);
  },
);

export const resetFormBundleFormStoreAction = () => dispatch =>
  dispatch({
    type: FORM_BUNDLE_FORM_ACTION_TYPE.RESET_STORE,
  });
